import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import { Badge, Col, Card, Row } from "react-bootstrap";
import moment from "moment";
import { Plus, DollarSign, ShoppingBag } from "react-feather";

const Statistics = (props: any) => {
  // const { t } = useTranslation();
  const { ads, ...rest } = props;
  const [adsAge, setAdsAge] = useState<number>(0);
  const [adsAvgValue, setAdsAvgValue] = useState<number>(0);

  const currencyFormatter = new Intl.NumberFormat("sl-SI", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });

  useEffect(() => {
    if (!ads) {
      return;
    }
    const totalValue = ads.reduce((acc: number, ad: any) => {
      if (ad.latestPrice) {
        acc += ad.latestPrice;
      }
      return acc;
    }, 0);

    const totalAge = ads.reduce((acc: number, ad: any) => {
      if (ad.year) {
        acc += moment().year() - ad.year;
      }
      return acc;
    }, 0);

    setAdsAge(totalAge / (ads.length || 1));
    setAdsAvgValue(totalValue / (ads.length || 1));
  }, [ads]);

  return (
    <Row>
      <Col md="4" xl className="d-flex">
        <Card className="flex-fill">
          <Card.Body className="py-4">
            <div className="d-flex align-items-start">
              <div className="flex-grow-1">
                <h3 className="mb-2">{ads.length}</h3>
                <p className="mb-2">Dodanih</p>
                {/*<div className="mb-0">
                  <Badge bg="" className="badge-soft-success me-2">
                    +5.35%
                  </Badge>
                  <span className="text-muted">Od včeraj</span>
                </div>*/}
              </div>
              <div className="d-inline-block ms-3">
                <div className="stat">
                  <Plus className="align-middle text-success" />
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col md="4" xl className="d-flex">
        <Card className="flex-fill">
          <Card.Body className=" py-4">
            <div className="d-flex align-items-start">
              <div className="flex-grow-1">
                <h3 className="mb-2">{adsAge.toFixed(2)} let</h3>
                <p className="mb-2">Povprečna starost vozila</p>
              </div>
              <div className="d-inline-block ms-3">
                <div className="stat">
                  <ShoppingBag className="align-middle text-success" />
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col md="4" xl className="d-flex">
        <Card className="flex-fill">
          <Card.Body className=" py-4">
            <div className="d-flex align-items-start">
              <div className="flex-grow-1">
                <h3 className="mb-2">
                  {currencyFormatter.format(adsAvgValue)}
                </h3>
                <p className="mb-2">Povprečna vrednost vozila</p>
                {/*<div className="mb-0">
                  <Badge bg="" className="badge-soft-success me-2">
                    +8.65%
                  </Badge>
                  <span className="text-muted">Od včeraj</span>
                </div>*/}
              </div>
              <div className="d-inline-block ms-3">
                <div className="stat">
                  <DollarSign className="align-middle text-success" />
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Statistics;
